import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  realm: import.meta.env.VITE_KEYCLOAK_REALM as string,
  url: import.meta.env.VITE_KEYCLOAK_AUTH_SERVER_URL as string,
  clientId: import.meta.env.VITE_KEYCLOAK_RESOURCE as string,
});

export default keycloak;
